export default "/images/tick_small_edit.png?a95529af9f4542af3cb36879d6218298";